export { useMaterialTailwind, MaterialTailwindProvider } from './materialTailwindContext';

export { useUserContext, UserContextProvider } from './userContext';

export const setOpenSidenav = (dispatch, value) =>
    dispatch({ type: "OPEN_SIDENAV", value });
export const setSidenavType = (dispatch, value) =>
    dispatch({ type: "SIDENAV_TYPE", value });
export const setSidenavColor = (dispatch, value) =>
    dispatch({ type: "SIDENAV_COLOR", value });